module.exports = __webpack_public_path__ + "static/img/image_c_pineapple.3567464.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_c_pineapple.jpg
// module id = OeuN
// module chunks = 1